import React from "react";
import LoanList from "./FoodAllowanceList";

const FoodAllowance = () => {
  return (
    <div>
      <LoanList />
    </div>
  );
};

export default FoodAllowance;
